import { useParams } from '@tanstack/react-router';
import { lazy } from 'react';
import { GarageGate } from '../lib/gate.js';

const CustomerScreen = lazy(() => import('../screens/CustomerScreen.js'));

/** Fiche client (Base garage) : coordonnées, remarque interne, véhicules, données personnelles. */
export default function CustomerPage() {
  const { customerId } = useParams({ strict: false });
  return <GarageGate>{customerId ? <CustomerScreen key={customerId} customerId={customerId} /> : null}</GarageGate>;
}
